import {LitElement} from 'lit';
import {customElement, queryAll} from 'lit/decorators.js';

@customElement('sbk-ogs-photo')
export class SbkOgsPhoto extends LitElement {

    @queryAll('.upload-button')
    _uploadButtons!: HTMLElement[];

    connectedCallback() {
        super.connectedCallback();
        this._uploadButtons.forEach((uploadButton) => {
            uploadButton.addEventListener('click', () => {
                this._writeContactHistory(uploadButton)
            });
        });
    }

    protected createRenderRoot() {
        return this
    }

    private _writeContactHistory(uploadButton: HTMLElement) {
        const type: string | undefined = uploadButton.dataset.mmsogsContacthistory  ?? ''
        const code: string | undefined = uploadButton.dataset.mmsogsCode ?? ''

        const host = window.location.origin
        fetch(`${host}/ajax/ogs/contactHistory?type=${type}&code=${code}`, {
            method: 'GET',
        })
            .then((response) => {
                return response.text()
            })
    }
}
